/* global angular, moment, google */
(function () {
  'use strict';
  angular.module('vcutils.map')
    .component('vcmap', {
      restrict: 'E',
      bindings: {
        data: '=',
        redraw: '<',
        lat: '<?',
        lng: '<?',
        height: '<?',
        zoom: '<?',
        plotroot: '@?',
        addrname: '@?',
        zipname: '@?',
        cityname: '@?',
        ownerscope: '<?',
        clickcb: '&?',
        iconresolver: '&?',
      },
      template: ` 
            <div id="map">           
            `,
      controllerAs: 'vm',
      controller: ['$log', '$http', '$rootScope', '$element', 'lodash', '$timeout', '$window',
        function ($log, $http, $rootScope, $element, _, $timeout, $window) {
          let vm = this;
          vm.markers = [];
          vm.drawMarker = drawMarker;


          vm.$onInit = function () {
            if (angular.isUndefined(vm.zoom)) {
              vm.zoom = 14;
            }
            if (angular.isUndefined(vm.lat)) {
              vm.lat = 48.2082;
            }
            if (angular.isUndefined(vm.lng)) {
              vm.lng = 16.3738;
            }
            if (angular.isDefined(vm.height) && vm.height === '100%') {
              angular.element($element[0].children[0]).css('height', ($window.innerHeight - 45) + 'px');
            } else {
              angular.element($element[0].children[0]).css('height', '400px');
            }
            if (angular.isUndefined(vm.addrname)) {
              vm.addrname = 'address';
            }
            if (angular.isUndefined(vm.zipname)) {
              vm.zipname = 'postcode';
            }
            if (angular.isUndefined(vm.cityname)) {
              vm.cityname = 'city';
            }

            // initalise map
            // noinspection JSUnresolvedVariable
            // noinspection JSUnresolvedFunction
            vm.map = new google.maps.Map($element[0].children[0], {
              zoom: vm.zoom,
              center: {lat: vm.lat, lng: vm.lng}
            });

            // get geocoder
            // noinspection JSUnresolvedVariable
            // noinspection JSUnresolvedFunction
            vm.geocoder = new google.maps.Geocoder();

            // Cordova built apps have a problem with the custom resolve, data was not ready, added comfort delay
            $timeout(function () {
              for (let i = 0; i < vm.data.length; i++) {
                drawMarker(vm.data[i]);
              }
            }, 3000);
            /*            for (let i = 0; i < vm.data.length; i++) {
                          drawMarker(vm.data[i]);
                        }*/
          };


          // use redraw binding to redraw map data
          this.$onChanges = (changes) => {
            if (changes.redraw && !changes.redraw.isFirstChange()) {
              $log.debug('change detected: ', changes.redraw);
              // get rid of existing markers
               for (let i = 0; i < vm.markers; i++) {
                 // noinspection JSUnresolvedFunction
                 vm.markers[i].setMap(null);
               }
              // draw set of current markers
              $timeout(function (){
                for (let i = 0; i < vm.data.length; i++) {
                  $log.debug('data i address', vm.data[i].building.address);
                  drawMarker(vm.data[i]);
                }
              }, 1000);
            }
          };


          function drawMarker(dataset) {
            let position;
            let datapoint;

            // noinspection JSUnresolvedVariable
            if (angular.isDefined(vm.plotroot)) {
              // noinspection JSUnresolvedVariable
              datapoint = _.get(dataset, vm.plotroot);
            } else {
              datapoint = dataset;
            }


            if (angular.isDefined(datapoint[vm.addrname]) && angular.isDefined(datapoint[vm.zipname]) && angular.isDefined(datapoint[vm.cityname])) {
              position = datapoint[vm.addrname] + ', ' + datapoint[vm.zipname] + ' ' + datapoint[vm.cityname];
            } else if (angular.isDefined(datapoint[vm.addrname])) {
              position = datapoint[vm.addrname];
            }

            // noinspection JSUnresolvedFunction
            vm.geocoder.geocode({'address': position}, function (results, status) {
              let icon;
              let image;
              if (status === 'OK') {
                // noinspection JSUnresolvedFunction JSUnresolvedVariable
                vm.map.setCenter(results[0].geometry.location);
                if (angular.isDefined(vm.iconresolver) && angular.isFunction(vm.iconresolver)) {
                  // noinspection JSUnresolvedFunction
                  icon = vm.iconresolver({datapoint: dataset});
                }
                else {
                  // icon = '/img/marker_rot.png'
                  icon = 'data:image/png;base64,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';
                }
                $log.debug('icon :', icon);
                // noinspection JSUnresolvedVariable
                image = {
                  url: icon,
                  scaledSize: new google.maps.Size(20, 32),
                };
                $log.debug('marker: ', results[0].geometry);
                // noinspection JSUnresolvedVariable
                let marker = new google.maps.Marker({
                  map: vm.map,
                  position: results[0].geometry.location,
                  icon: image
                });


                vm.markers.push(marker);

                // noinspection JSUnresolvedVariable
                if (angular.isDefined(vm.clickcb) && angular.isFunction(vm.clickcb)) {
                  marker.addListener('click', function () {
                    // $log.debug('map marker clicked: ', marker);
                    // noinspection JSUnresolvedFunction
                    return vm.clickcb({datapoint: dataset, marker: marker})
                  });
                }


              } else {
                $log.error('Geocode was not successful for the following reason: ' + status);
              }
            });

          }


        }
      ] // controller
    }); // component

  // klammerfriedhof
}());